import React from 'react'
import { Link } from 'react-router-dom'
import Hidden from '@material-ui/core/Hidden';
const ArticleBox = ({ article, lang }) => {
    const tr = (short) => {
        var maxLength = 100;
        return short.substring(0, maxLength) + '...';
    }
    return (
        <div className="article">
            <div className="top" style={{ backgroundImage: `url(${article.imgURL})` }}>
                <div className="content">
                    <h1>{article.title}</h1>
                    <Hidden only={['xs']}>
                        <p style={{ textAlign: 'justify' }}>{tr(article.shortDescription)}</p>
                    </Hidden>
                </div>
            </div>
            <div className="bottom">
                <Link to={`/article/${article.id}/${article.title.replace(/\s+/g, '-')}`}> {lang === "ar" ? "قرأ المقال " : "خواندن مقاله"}</Link>
            </div>
        </div>
    )
}

export default ArticleBox
